import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.radioTargets.forEach((r) => {
      r.closest(".option-card").classList.toggle("is-selected", r.checked)
    })
  }
}
